<template>
  <div>
    <div>
      <search-bar></search-bar>
    </div>
    <div v-if="result && isfound">
      <school-info :info="school_info"></school-info>
    </div>
    <div v-if="result && isfound">
      <v-container fluid grid-list-sm class="py-0">
        <v-card>
          <v-tabs
            v-model="active"
            background-color="primary"
            dark
            slider-color="yellow"
          >
            <v-tab ripple href="#t7" :disabled="!grade.g7">ថ្នាក់ទី ៧</v-tab>
            <v-tab ripple href="#t8" :disabled="!grade.g8">ថ្នាក់ទី ៨</v-tab>
            <v-tab ripple href="#t9" :disabled="!grade.g9">ថ្នាក់ទី ៩</v-tab>
            <v-tab ripple href="#t10" :disabled="!grade.g10">ថ្នាក់ទី ១០</v-tab>
            <v-tab ripple href="#t11" :disabled="!grade.g11">ថ្នាក់ទី ១១</v-tab>
            <v-tab ripple href="#t12" :disabled="!grade.g12">ថ្នាក់ទី ១២</v-tab>

            <v-tab-item id="t7">
              <div v-if="grade.g7 > 0 && score.sco_g7 != null">
                <b>១.ថ្នាក់ទី ៧</b>
                <grade-79 :scoreData="score.sco_g7" grade="0"></grade-79>
                <!-- Grade 7-->
              </div>
            </v-tab-item>
            <v-tab-item id="t8">
              <div v-if="grade.g8 > 0 && score.sco_g8 != null">
                <b>២.ថ្នាក់ទី ៨</b>
                <grade-79 :scoreData="score.sco_g8" grade="0"></grade-79>
                <!-- Grade 8-->
              </div>
            </v-tab-item>
            <v-tab-item id="t9">
              <div v-if="grade.g9 > 0 && score.sco_g9 != null">
                <b>៣.ថ្នាក់ទី ៩</b>
                <grade-79 :scoreData="score.sco_g9" grade="1"></grade-79>
                <!-- Grade 9-->
              </div>
            </v-tab-item>
            <v-tab-item id="t10">
              <div v-if="grade.g10 > 0 && score.sco_g10 != null">
                <b>៤.ថ្នាក់ទី ១០</b>
                <grade-10 :scoreData="score.sco_g10"></grade-10>
                <!-- Grade 10-->
              </div>
            </v-tab-item>
            <v-tab-item id="t11">
              <div v-if="grade.g11 > 0 && score.sco_g11 != null">
                <div>
                  <b>៥.ថ្នាក់ទី ១១ (វិទ្យាសាស្រ្ត)</b>
                  <grade-11-12
                    :scoreData="score.sco_g11"
                    grade="0"
                  ></grade-11-12>
                  <!-- Grade 11 science-->
                </div>
                <div>
                  <b>៦.ថ្នាក់ទី ១១ (វិទ្យាសាស្រ្តសង្គម)</b>
                  <grade-11-12
                    :scoreData="score.sco_g18"
                    grade="1"
                  ></grade-11-12>
                  <!-- Grade 11-18 social -->
                </div>
              </div>
            </v-tab-item>
            <v-tab-item id="t12">
              <div v-if="grade.g12 > 0 && score.sco_g12 != null">
                <div>
                  <b>៧.ថ្នាក់ទី ១២ (វិទ្យាសាស្រ្ត)</b>
                  <grade-11-12
                    :scoreData="score.sco_g12"
                    grade="0"
                  ></grade-11-12>
                  <!-- Grade 12 science-->
                </div>
                <div>
                  <b>៨.ថ្នាក់ទី ១២ (វិទ្យាសាស្រ្តសង្គម)</b>
                  <grade-11-12
                    :scoreData="score.sco_g19"
                    grade="1"
                  ></grade-11-12>
                  <!-- Grade 12-19 social -->
                </div>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-container>
    </div>
    <div v-if="result && isfound">
      <navigation-bar></navigation-bar>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import SearchBar from "@/components/common/SearchBar.vue";
import SchoolInfo from "@/components/common/SchoolInfo.vue";
import Grade79 from "@/components/qemis/Grade79.vue";
import Grade10 from "@/components/qemis/Grade10.vue";
import Grade1112 from "@/components/qemis/Grade1112.vue";
import NavigationBar from "@/components/common/NavigationBar.vue";
import puQemisSecModule from "@/store/modules/puqemissec/index";

export default {
  name: "QEMISSecondary",
  components: {
    searchBar: SearchBar,
    schoolInfo: SchoolInfo,
    Grade79: Grade79,
    Grade10: Grade10,
    Grade1112: Grade1112,
    navigationBar: NavigationBar,
  },
  data() {
    return {
      isfound: false,
      active: "t7",
    };
  },
  methods: {},
  computed: {
    /* eslint-disable */

    result: function () {
      if (this.$store.state.puqemissec.school_dt.res === "1") {
        this.isfound = true;
        this.active =
          this.$store.state.puqemissec.school_dt.type_code === 4 ? "t10" : "t7";
        return true;
      } else {
        return false;
      }
    },

    /* eslint-enable */
    ...mapGetters({
      school_info: "puqemissec/getSchoolInfo",
      grade: "puqemissec/getGrade",
      score: "puqemissec/getScore",
    }),
  },
  mounted() {
    this.$store.dispatch("puqemissec/loadDefaultQEMISsec");
    //this.$store.dispatch("uiControl/setEnableSave");
  },
  beforeDestroy() {
    // this.$store.unregisterModule("puqemissec");
  },
  created() {
    if (!this.$store._modules.root._children[`puqemissec`]) {
      this.$store.registerModule("puqemissec", puQemisSecModule);
    }
  },
};
</script>

